import { useEffect, useState } from 'react';
import { Field, Form } from 'react-final-form';
import { Button } from 'reactstrap';
import ContentLoader from 'react-content-loader';
import Sticky from 'react-stickynode';
import classNames from 'classnames';

import CustomCheckBox from '../../../components/form/CustomCheckBox';
import Panel from '../../../components/Panel';

import useWindowSize from '../../../hooks/useWindowSize';
import { BootstrapBreakpoints } from '../../../utils/constants';
import { useDict } from '../../../contexts/LanguageContext';
import { appendLocale } from '../../../utils/helper';
import { getCashflowTypeFilter } from '../src/transactionApis';

const Filtering = (props) => {
    const { filterTransactionData, isFetching } = props;

    const dict = useDict();

    const [initialTransactionTypeSlugs, setInitialTransactionTypeSlugs] = useState([]);
    const [transactionFilterData, setTransactionFilterData] = useState([]);

    useEffect(() => {
        getCashflowTypeFilter(handleGetCashflowTypeFilter);
    }, []);

    const handleGetCashflowTypeFilter = (response) => {
        setTransactionFilterData(response.data.data);

        const transactionTypeSlugArr = response.data.data.reduce(
            (arr, data) => {
                const draft = arr;
                draft.push(data.slug);
                return arr;
            },
            []
        );

        setInitialTransactionTypeSlugs(transactionTypeSlugArr);
    };

    const { width } = useWindowSize();
    const [isSticky, setIsSticky] = useState(false);

    const isMobile = width <= BootstrapBreakpoints.SM;

    const colClassName = classNames({
        'px-0': isSticky,
        'px-2': !isSticky,
    });

    const innerActiveClass = classNames({
        'panel--sticky': isMobile,
        'mt-2': !isMobile,
    });

    const transactionFilterValidation = (values) => {
        const errors = {};
        if (values?.transactionTypeSlugs?.length < 1) {
            errors.alert = dict.transactionTypeEmpty;
        }
        return errors;
    };

    const handleSubmit = (values, form) => {
        filterTransactionData(values);
        form.initialize(values);
    }

    return (
        <Sticky
            top=".container" // .container because parent componet has container classname
            onStateChange={(state) => {
                if (state.status === Sticky.STATUS_FIXED) {
                    setIsSticky(true);
                } else {
                    setIsSticky(false);
                }
            }}
            innerActiveClass={innerActiveClass}
        >
            <Panel
                xs={12}
                title={dict.transactionType}
                colClassName={colClassName}
                collapsable={isMobile}
                panelClassName="transaction-panel"
            >
                {isFetching ? (
                    [...Array(4)].map((_, index) => (
                        <ContentLoader
                            width="70%"
                            height="20"
                            gradientDirection="top-bottom"
                            backgroundColor="#eee"
                            foregroundOpacity={0.3}
                            className="mb-4"
                            key={`content-loader-${index}`}
                        >
                            <rect
                                width="20px"
                                height="100%"
                                x="0"
                                y="0"
                                rx="5"
                                ry="5"
                            />
                            <rect
                                width="70%"
                                height="100%"
                                x="30"
                                y="0"
                                rx="5"
                                ry="5"
                            />
                        </ContentLoader>
                    ))
                ) : (
                    <Form
                        initialValues={{
                            transactionTypeSlugs: initialTransactionTypeSlugs,
                        }}
                        validate={transactionFilterValidation}
                        onSubmit={(values, form) => { handleSubmit(values, form) }}
                    >
                        {({ dirty, handleSubmit }) => (
                            <form onSubmit={handleSubmit} className="mt-3">
                                {transactionFilterData?.map(
                                    (transactionFilter) => (
                                        <div
                                            className="mb-3"
                                            key={transactionFilter.slug}
                                        >
                                            <Field
                                                name="transactionTypeSlugs"
                                                type="checkbox"
                                                value={transactionFilter.slug}
                                            >
                                                {({ input, meta }) => (
                                                    <CustomCheckBox
                                                        input={input}
                                                        meta={meta}
                                                        label={
                                                            transactionFilter[appendLocale('name')]
                                                        }
                                                        data-cy={`filter__checkbox--${transactionFilter.slug}`}
                                                    />
                                                )}
                                            </Field>
                                        </div>
                                    )
                                )}
                                <Field name="alert" type="checkbox">
                                    {({ meta }) =>
                                        meta.error ? (
                                            <p className="text-danger">
                                                {meta.error}
                                            </p>
                                        ) : null
                                    }
                                </Field>
                                {dirty && (
                                    <Button
                                        type="submit"
                                        className="mb-0 w-100 mt-3"
                                        color="primary"
                                        data-cy="filter_btn--submit"
                                    >
                                        {dict.apply}
                                    </Button>
                                )}
                            </form>
                        )}
                    </Form>
                )}
            </Panel>
        </Sticky>
    );
};

export default Filtering;
